export default "__VITE_ASSET__b2157881__"